import { useEffect, useContext, useMemo } from 'react';
import { useFlag } from '@openfeature/react-sdk';
import { FEATURE_FLAGS } from '../../../constants/constants';
import { OrgLevelSettingsContext } from './NROrgLevelSettingsContextWrapper';
import useNRLazyQuery from '../../../graphql/useNRLazyQuery';
import { buildGetOrgLevelSettings } from '../../../graphql/queries/orgs';
import isEqual from 'lodash.isequal';

const useFetchOrgLevelSettings = () => {
  const { setOrgLevelSettings, orgLevelSettings, refetch, setRefetch } = useContext(OrgLevelSettingsContext);

  const { value: isRiseAiConversationalGptEnabled } = useFlag(FEATURE_FLAGS.RISE_AI_CONVERSATIONAL_GPT_SETTINGS, false);
  const { value: isRiseAIInsightsReportEnabled } = useFlag(FEATURE_FLAGS.RISE_AI_INSIGHTS_REPORT_SETTINGS, false);
  const { value: isAutoRemediationsSettingsEnabled } = useFlag(FEATURE_FLAGS.AUTO_REMEDIATIONS_SETTINGS, false);
  const { value: isSecretScanningSettingsEnabled } = useFlag(FEATURE_FLAGS.SECRET_SCANNING_SETTINGS, false);
  const { value: isAdvancedSettingsEnabled } = useFlag(FEATURE_FLAGS.ADVANCED_SETTINGS, false);

  const GET_ORG_LEVEL_SETTINGS = useMemo(
    () =>
      buildGetOrgLevelSettings({
        isRiseAiConversationalGptEnabled,
        isRiseAIInsightsReportEnabled,
        isAutoRemediationsSettingsEnabled,
        isSecretScanningSettingsEnabled,
        isAdvancedSettingsEnabled
      }),
    [
      isRiseAiConversationalGptEnabled,
      isRiseAIInsightsReportEnabled,
      isAutoRemediationsSettingsEnabled,
      isSecretScanningSettingsEnabled,
      isAdvancedSettingsEnabled
    ]
  );

  const [, , called, makeRequest] = useNRLazyQuery({
    query: GET_ORG_LEVEL_SETTINGS,
    options: {
      fetchPolicy: 'cache-first'
    },
    qlObjKey: 'orgLevelSettings',
    transformData: data => {
      if (!isEqual(orgLevelSettings, data)) {
        setOrgLevelSettings(data);
      }
    }
  });

  useEffect(() => {
    if ((!orgLevelSettings && !called) || !!refetch) {
      setRefetch(false);
      makeRequest({ fetchPolicy: refetch ? 'network-only' : 'cache-first' });
    }
  }, [refetch, orgLevelSettings, called, GET_ORG_LEVEL_SETTINGS]);
};

export default useFetchOrgLevelSettings;
